<script lang="ts">
	import { onMount } from 'svelte';
	import { ExhibitionsIcon } from './ExhibitionsIcon';
	import { NavBar } from '#lib/features/navigation/components/NavBar/index.js';
	import { GlobalSearch } from '#lib/features/search/global/components/GlobalSearch/index.js';
	import { getTimeContext } from '#lib/features/time/utils/getTimeContext/getTimeContext.js';
	import { page } from '$app/state';
	import { SearchPageContainer } from '$global/features/search/components/SearchPageContainer';
	import { createSearchCombobox } from '$global/features/search/utils/createSearchCombobox';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
	const combobox = createSearchCombobox();

	const { fetchTime, interval } = getTimeContext();

	let mounted = $state(false);

	onMount(() => {
		mounted = true;

		return () => {
			if ($interval) {
				clearInterval($interval);
			}

			interval.set(null);
		};
	});

	$effect(() => {
		if (mounted && (page.url.pathname || page.url.search)) {
			fetchTime();
		}
	});
</script>

<NavBar
	siteLinks={[]}
	{combobox}
	SearchComponent={GlobalSearch}
	isSearchEnabled={true}
>
	{#snippet homeIcon()}
		<ExhibitionsIcon />
	{/snippet}
</NavBar>

<SearchPageContainer {combobox}>
	{@render children?.()}
</SearchPageContainer>
